<template>
  <span class="premium-badge" :class="{ small: size === 'small' }">
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
    </svg>
  </span>
</template>

<script>
export default {
  name: 'PremiumBadge',
  props: {
    size: {
      type: String,
      default: 'normal',
      validator: (value) => ['small', 'normal'].includes(value)
    }
  }
}
</script>

<style scoped>
.premium-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffa500;
  width: 16px;
  height: 16px;
  vertical-align: middle;
}

.premium-badge svg {
  width: 100%;
  height: 100%;
}

.premium-badge.small {
  width: 12px;
  height: 12px;
}
</style>
